import firebase from 'firebase';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/messaging';

const {
  REACT_APP_FIREBASE_KEY,
  REACT_APP_FIREBASE_DOMAIN,
  REACT_APP_FIREBASE_DATABASE,
  REACT_APP_FIREBASE_PROJECT_ID,
  REACT_APP_FIREBASE_STORAGE_BUCKET,
  REACT_APP_FIREBASE_SENDER_ID
} = process.env;

const config = {
  apiKey: REACT_APP_FIREBASE_KEY,
  authDomain: REACT_APP_FIREBASE_DOMAIN,
  databaseURL: REACT_APP_FIREBASE_DATABASE,
  projectId: REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: REACT_APP_FIREBASE_SENDER_ID
};

export const firebaseApp = firebase.initializeApp(config);

export const auth = firebaseApp.auth();

export const messaging = firebase.messaging();
messaging.usePublicVapidKey("BAsGP5yKJTdbPxbJlbVxWGd7DnEpf6_z7lgoKc5JQNODRWeMxhN7qmZtDMn0Ixl3Tu6TQh3aZ98Pa-sNiPGMWIs");
//messaging.useServiceWorker();

// Handle incoming messages. Called when:
// - a message is received while the app has focus
// - the user clicks on an app notification created by a service worker
//   `messaging.setBackgroundMessageHandler` handler.
messaging.onMessage(function(payload) {
  console.log('Message received. ', payload);
});

const setTokenSentToServer = (sent) => {
  window.localStorage.setItem('sentToServer', sent ? '1' : '0');
};
const isTokenSentToServer = () => {
  return false;
  //return window.localStorage.getItem('sentToServer') === '1';
};
const updateUIForPushEnabled = () => {};

export const initMessaging = new (function () {
  console.log("Initialized.");

  this.sendTokenToServerIfNeeded = () => {
    throw new Error("Messaging precisa ser inicializado.");
  }

  this.init = (sendTokenToServerIfNeeded) => {
    this.sendTokenToServerIfNeeded = sendTokenToServerIfNeeded;
  };
  this.request = updateUIForPushPermissionRequired;

  const sendTokenToServer = (token) => {
    if (!isTokenSentToServer()) {
      console.log('Sending token to server...');
      // TODO(developer): Send the current token to your server.
      setTokenSentToServer(true);
      this.sendTokenToServerIfNeeded(token);
    } else {
      console.log('Token already sent to server so won\'t send it again unless it changes');
    }
  };

  messaging.onTokenRefresh(function() {
    console.log("refresh");
    messaging.getToken().then(function(refreshedToken) {
        console.log('Token refreshed.');
        // Indicate that the new Instance ID token has not yet been sent to the
        // app server.
        setTokenSentToServer(false);
        // Send Instance ID token to app server.
        sendTokenToServer(refreshedToken);
        // ...
    }).catch(function(err) {
        console.log('Unable to retrieve refreshed token ', err);
        //showToken('Unable to retrieve refreshed token ', err);
    });
  });
  
  function updateUIForPushPermissionRequired () {
    return Notification.requestPermission().then(function() {
      console.log('Notification permission granted.');
      // TODO(developer): Retrieve an Instance ID token for use with FCM.
      // ...
      return initToken();
    }).catch(function(err) {
      console.log('Unable to get permission to notify.', err);
      return false;
    }); 
  }

  function initToken () {
    // Get Instance ID token. Initially this makes a network call, once retrieved
    // subsequent calls to getToken will return from cache.
    return messaging.getToken().then(function(currentToken) {
        console.log("token", currentToken);
        if (currentToken) {
            sendTokenToServer(currentToken);
            updateUIForPushEnabled(currentToken);
            return true;
        } else {
            // Show permission request.
            console.log('No Instance ID token available. Request permission to generate one.');
            // Show permission UI.
            setTokenSentToServer(false);
            alert('Deveria solicitar permissão.');
            return false;
            //return updateUIForPushPermissionRequired();
        }
    }).catch(function(err) {
      alert(err);
        console.log('An error occurred while retrieving token. ', err);
        //showToken('Error retrieving Instance ID token. ', err);
        setTokenSentToServer(false);
        return false;
    });
  }
})();

export const firestore = firebaseApp.firestore();

export default firebase;



// WEBPACK FOOTER //
// ./src/base.js